$(document).ready(function(){
  
  var email_regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

  $('html').removeClass('no-js').addClass('js');
  
    $('.ar_slideshow_slider').slick({
      infinite: true,
      dots:false,
      arrows:false
    });	
    
    $('.quote-slider').slick({
      infinite: true,
      dots:false,
      fade: true,
      autoplay: true,
      autoplaySpeed: 2000,
      nextArrow: '<span class="arrow-right"></span>',
      prevArrow: '<span class="arrow-left"></span>',
      responsive: [
        {
          breakpoint: 767,
          settings: {
            fade: false,
            arrows: false
          }
        }
      ]
    });			

    if($(window).width() <= 767) {
      $('.hp-coll-slider').slick({
        infinite: false,
        dots:false,
        arrows: false,
        slidesToShow: 3,
        nextArrow: '<span class="arrow-right"></span>',
        prevArrow: '<span class="arrow-left"></span>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              dots:true
            }
          }
        ]
      });
    }

    $(window).ready(function(){
      if($(window).width() >= 768) {
        $('.c-grid .item:nth-child(3n+0)').after('<div class="ptrn-line clearfix"><div class="prtn-bx"></div></div>');
      }
      $(window).resize(function(){
        if($(window).width() <= 767) {
          $('.c-grid .ptrn-line').remove();
        }
      });
    });

    $('#menu-icon').on('click', function(){
//       $('body').toggleClass('o-hidden');
      $('header').toggleClass('open');
      $('header .main-menu').toggleClass('open');
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $('.mega').removeClass('open');
        $('.mega-menu').removeClass('close-menu');
        $('.mega-menu div').removeClass('open');
      } else {
        $(this).addClass('active');
      }

    });
    
    // product page //
    
    $(window).scroll(function () {
      if ($(this).scrollTop() > $(window).height() - 1 - $(".product-i-nav").height()) {
        $('.template-product header').addClass('hide');
        $('.template-product .product-i-nav').addClass('show');
      } else {
        $('.template-product header').removeClass('hide');
        $('.template-product .product-i-nav').removeClass('show');
      }
    });
    
    $('.rotateWatch').on('click', function(){
      $('.featured').toggle();
      $('.caseback').toggle();
    });

    $('.exp-i-toggle').on('click', function(){
      $('.icon-eye-crossed').toggle();
      $('.icon-eye').toggle();
      $('.point').fadeToggle(300);
    });

    // POI Explorer
    var circle = '.exp-bx .point .circle';

    $(circle).on('click', function() {
      // toggle symbol in circle
      $(this).parent().addClass('open');
      $(circle).not(this).parent().removeClass('open');

      // switch content
      var poiID = $(this).parent().data("poi");

      $('.exp-content').not('#' + poiID).fadeOut(200);
      setTimeout(function(){
        $('.exp-content#' + poiID).fadeIn(200);
      }, 300);

    });

    $('.explore-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
      var item = $('.explore-slider .slick-current').attr("data-slick-index");
      $('.explore-slider').find(".exp-images").eq(item).find('.circle').first().trigger( "click" );
    });

    $(document).ready(function(){
      $('.explore-slider').slick({
        infinite: true,
        dots:true,
        fade: true,
        speed: 300,
        cssEase: 'linear',
        nextArrow: '<span class="arrow-right"></span>',
        prevArrow: '<span class="arrow-left"></span>'
      });	

      $('.releted-slider').slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots:true,
        fade: false,
        nextArrow: '<span class="arrow-right"></span>',
        prevArrow: '<span class="arrow-left"></span>',
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
          }
        ]
      });			
    });

    if($(window).width() <= 767) {
      $('.accordion .title').on('click', function(){
        if($(this).hasClass('open')){
          $(this).removeClass('open');
          $(this).parent('.accordion').find('.content').slideUp();
        } else {
          $(this).addClass('open');
          $(this).parent('.accordion').find('.content').slideDown();
        }
      });
    }
  
//   $(document).on('click','.add-cart-btn',function(){
//     var form = $(this).parents('form');
//     var pro_id = $(this).attr('data-id');
//     addtocart(pro_id); 
//   });

  // end product page //
  
  /*  Cart page and minicart */
  
  $(document).on('click','.cart-form .qty-minus, .cart-form .qty-plus', function(){
    var curr_val = $(this).parents('.cart-qty').find('input[type="number"]').val();
    var curr_id = $(this).parents('.cart-qty').find('.qty-cart').attr('data-id');
      if($(this).attr('data') == 'minus') {
        if(curr_val != 0) {
          curr_val--;
        }
      }
      else {
        curr_val++;
      }
    
      var err_msg = '';

      if($(this).parents('.cart-qty').find('.qty-cart').attr('max') != '' && curr_val > $(this).parents('.cart-qty').find('.qty-cart').attr('max')) {
        curr_val = $(this).parents('.cart-qty').find('.qty-cart').attr('max');
        err_msg = 'All '+curr_val+' '+$(this).parents('.cart-qty').attr('data-title')+' in your cart';
      }
      else {
        $(this).parents('.cart-qty').find('input[type="number"]').val(curr_val);
      }
    
      $('.img-loader').show();
      cart_update(curr_id, curr_val, err_msg);
  });
  
  
  $(document).on('change', '.qty-cart', function(){
    var curr_qty = $(this).val();
    var curr_id = $(this).attr('data-id');
    var err_msg = '';

    if($(this).attr('max') != '' && curr_qty > $(this).attr('max')) {
      curr_qty = $(this).attr('max');
      err_msg = 'All '+curr_qty+' '+$(this).parents('.cart-qty').attr('data-title')+' in your cart';
    }
    
    cart_update(curr_id,curr_qty,err_msg);
    $('.img-loader').show();
  });
  
  $('.btn-check_out').click(function(){
    var $form = $(this).parents('form');
    var checked = $form.find('input[name="chk"]').prop('checked');
    if(checked == false ){
      $form.find('.error-checked').text('You must agree with our Terms & Conditions to check out');
      $form.find('input#agree').focus();
      return false;
    }
    else{
     $form.find('.error-checked').text('');
    }
  });
  
  $(document).on('click','.hd-cart-remove',function(){
    $('.img-loader').show();
    var line_item = $(this).attr('data-line');
    var qty = 0;
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
      data: {line: line_item, quantity: qty},
      success: function(data){
        $.ajax({
          type: 'GET',
          url: '/cart',
          dataType: 'html',
          success: function(cartdata){
            var minicart = $(cartdata).find('.mini-cart-page').html();
            $('.mini-cart-page').html(minicart);
            
            var cartCount =  $(cartdata).find('.cart-products-count').text();
            $('.cart-products-count').text(cartCount);

            $('.img-loader').hide();
          }
        });
      }
    });
  });
    
    /* end Cart page and minicart */
  
  /* Article page */
  $('.btn_artcle_comment').click(function(){
    var $form = $(this).parents('form');
    var txtname = $form.find('.txtname').val();
    var txtmail = $form.find('.txtmail').val();
    var txtmsg = $form.find('.txtmsg').val();
    
    if(txtname == ''){
      $form.find('.error-comment').text('Name is required');
      $form.find('.txtname').focus();
      return false;
    }
    else if(txtmail == ''){
      $form.find('.error-comment').text('Email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if( !txtmail.match(email_regex)) {
      $form.find('.error-comment').text('Valid email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if(txtmsg == ''){
      $form.find('.error-comment').text('Comment is required');
      $form.find('.txtmsg').focus();
      return false;
    }
    else {
      $form.find('.error-comment').text('');
    }
  });
  /* end Article page */
  
  /* login page */
  $('.btn-login').click(function(){
    var $form = $(this).parents('form');
    var txtmail = $form.find('.txtmail').val();
    var txtpwd = $form.find('.txtpwd').val();
    if(txtmail == ''){
      $form.find('.error-login').text('Email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if( !txtmail.match(email_regex)) {
      $form.find('.error-login').text('Valid email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if(txtpwd == '' ){
      $form.find('.error-login').text('Password is required');
      $form.find('.txtpwd').focus();
      return false;
    }
    else {
      $form.find('.error-login').text('');
    }

  });

  $('.btn-reset').click(function(){
    var $form = $(this).parents('form');
    var txtmail = $form.find('.txtemail').val();
    if(txtmail == ''){
      $form.find('.error-reset').text('Email is required');
      $form.find('.txtemail').focus();
      return false;
    }
    else if( !txtmail.match(email_regex)) {
      $form.find('.error-reset').text('Valid email is required');
      $form.find('.txtemail').focus();
      return false;
    }
    else {
      $form.find('.error-reset').text('');
    }

  });

  /* end login page */
  
  /* register page */
  $('.btn_register').click(function(){

    var $form = $(this).parents('form');
    var txtfname = $form.find('.txtfname').val();
    var txtlname = $form.find('.txtlname').val();
    var txtmail = $form.find('.txtemail').val();
    var txtpwd = $form.find('.txtpwd').val();

    if(txtfname == ''){
      $form.find('.error-register').text('Firstname is required');
      $form.find('.txtfname').focus();
      return false;
    }
    else if(txtlname == ''){
      $form.find('.error-register').text('Lastname is required');
      $form.find('.txtlname').focus();
      return false;
    }
    else if(txtmail == ''){
      $form.find('.error-register').text('Email is required');
      $form.find('.txtemail').focus();
      return false;
    }
    else if( !txtmail.match(email_regex)) {
      $form.find('.error-register').text('Valid email is required');
      $form.find('.txtemail').focus();
      return false;
    }
    else if(txtpwd == '' ){
      $form.find('.error-register').text('Password is required');
      $form.find('.txtpwd').focus();
      return false;
    }
    else {
      $form.find('.error-register').text('');
    }
  
  });
  
  /* end register page */
  
  /* address page */
    $('.btn-address').click(function(){
      var $form = $(this).parents('form');
      var txtfname = $form.find('.txtfname').val();
      var txtlname = $form.find('.txtlname').val();
      var txtaddress = $form.find('.txtaddress').val();
      var txtcity = $form.find('.txtcity').val();
      var selcountry = $form.find('.selcountry').val();
      var txtzip = $form.find('.txtzip').val();
      var txtphone = $form.find('.txtphone').val();

      var err_field = '';

      if(txtfname == '') {
        err_field = 'txtfname';
      }
      else if(txtlname == '') {
        err_field = 'txtlname';
      }
      else if(txtaddress == '') {
        err_field = 'txtaddress';
      }
      else if(txtcity == '') {
        err_field = 'txtcity';
      }
      else if(selcountry == '---') {
        err_field = 'selcountry';
      }
      else if(txtzip == '') {
        err_field = 'txtzip';
      }
      else if(txtphone == '') {
        err_field = 'txtphone';
      }
      $form.find('.form-error').text('');
      if(err_field != '') {
        $form.find('.'+err_field).focus();
        $form.find('.error-'+err_field).text("This field is required");
        return false;
      }
    });
  /* end address page */
  
  /* activate_account page */
  $('.btn-act_acc').click(function(){
    var $form = $(this).parents('form');
    var txtpswd = $form.find('.txtpswd').val();
    var txtcpswd = $form.find('.txt_c_pswd').val();

    if(txtpswd == ''){
      $form.find('.error-act_acc').text('Password is required');
      $form.find('.txtpswd').focus();
      return false;
    }
    else if(txtcpswd == ''){
      $form.find('.error-act_acc').text('Confirm password is required');
      $form.find('.txt_c_pswd').focus();
      return false;
    }
    else if(txtcpswd != txtpswd){
      $form.find('.error-act_acc').text("Password doesn't match with confirm password");
      $form.find('.txt_c_pswd').val('').focus();
      return false;
    }
    else{
      $form.find('.error-act_acc').text('');
    }
  });
  /* end activate_account page */
  
  
  /* reset_password page */
  $('.btn_reset_pwd').click(function(){
    var $form = $(this).parents('form');
    var txtpwd = $form.find('.txtpwd').val();
    var txtcpwd = $form.find('.txt_c_pwd').val();

    if(txtpwd == ''){
      $form.find('.error-reset-pwd').text('Password is required');
      $form.find('.txtpwd').focus();
      return false;
    }
    else if(txtcpwd == ''){
      $form.find('.error-reset-pwd').text('Confirm password is required');
      $form.find('.txt_c_pwd').focus();
      return false;
    }
    else if(txtcpwd != txtpwd){
      $form.find('.error-reset-pwd').text("Password doesn't match with confirm password");
      $form.find('.txt_c_pwd').val('').focus();
      return false;
    }
    else{
      $form.find('.error-reset-pwd').text('');
    }
  });
  /* end reset_password page */
  
  /* next project page */
  $('.btn-next-project').click(function(){
    var $form = $(this).parents('form');
    var txtname = $form.find('.txtname').val();
    var txtmail = $form.find('.txtmail').val();
    
    if(txtname == ''){
      $form.find('.error-next-project').text('Name is required');
      $form.find('.txtname').focus();
      return false;
    }
    else if(txtmail == ''){
      $form.find('.error-next-project').text('Email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else if(!txtmail.match(email_regex)) {
      $form.find('.error-next-project').text('Valid email is required');
      $form.find('.txtmail').focus();
      return false;
    }
    else {
      $form.find('.error-next-project').text('');
    }
  });
  /* end next project page */
  
});

/* product page */
function addtocart(obj){
  
  var form = $(obj).parents('form');
  var form_id = obj.id;
  var addbtn = "<span class='add_btn'>Add to cart</span>";
  var cart_items_html = "";
  $('.add_btn').text("Adding...");
  
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $('.pro-form-'+form_id).serialize(),
    dataType: 'json',
    success: function(response){
      $.ajax({
        type:"GET",
        url:"/cart.js",
        dataType: 'json',
        
        success: function(cart){
          $('.cart-products-count').text(cart.item_count);
          
          if (cart.item_count == 0) {
            $('.header-cart-empty').removeClass('hidden');
            $('.js-cart-form').addClass('hidden');
          } 
          else {
            $('.header-cart-empty').addClass('hidden');
            $('.js-cart-form').removeClass('hidden');
      
            $.each(cart.items, function(index, item) {
              var index = index + 1;
              cart_items_html += '<div class="hd-cart-item">';
                cart_items_html += '<img src="'+ item.image +'">';
                cart_items_html += '<div class="hd-cart-desc">';
                  cart_items_html += ' <span class="title">';
                    cart_items_html += '<a href="'+ item.url +'">'+ item.title +'</a>';
                  cart_items_html += '</span>';
                  cart_items_html += '<span class="price">'+ Shopify.formatMoney(item.price ,$('body').data('money-format')) +'</span>';
              
                  cart_items_html += '<span class="quantity">';
                    cart_items_html += '<div class="img-loader" style="display: none;">';
                      cart_items_html += '<div class="loader"></div>';
                    cart_items_html +=  '</div>';
              
                    cart_items_html += '<div class="qty cart-qty" data-title="'+ item.title +'">';
                      cart_items_html +=  '<button type="button" id="sub" class="sub qty-minus" data="minus">-</button>';
                        cart_items_html +=  '<input type="number" name="updates[]" min="0" id="updates_'+ item.id +' " class="qty-cart" value="'+ item.quantity +'" data-line="'+ index +'" data-id="'+ item.id +'" autocomplete="off">';
                      cart_items_html +=  '<button type="button" id="add" class="add qty-plus" data="plus">+</button>';
                    cart_items_html += '</div>';
              
                  cart_items_html += '</span>';
              
                  cart_items_html += '<a class="hd-cart-remove" data-line="'+ index +'">';
                    cart_items_html += '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 15.642 15.642">';
                      cart_items_html += '<path fill-rule="evenodd" d="M8.882,7.821l6.541-6.541c0.293-0.293,0.293-0.768,0-1.061  c-0.293-0.293-0.768-0.293-1.061,0L7.821,6.76L1.28,0.22c-0.293-0.293-0.768-0.293-1.061,0c-0.293,0.293-0.293,0.768,0,1.061  l6.541,6.541L0.22,14.362c-0.293,0.293-0.293,0.768,0,1.061c0.147,0.146,0.338,0.22,0.53,0.22s0.384-0.073,0.53-0.22l6.541-6.541  l6.541,6.541c0.147,0.146,0.338,0.22,0.53,0.22c0.192,0,0.384-0.073,0.53-0.22c0.293-0.293,0.293-0.768,0-1.061L8.882,7.821z"/>';
                    cart_items_html += '</svg>';
                  cart_items_html += '</a>';
              
                cart_items_html += '</div>';
              cart_items_html += '</div>';

            });
          
            $('.ajax-mini-cart').html(cart_items_html);
            $('.cart_total').html(Shopify.formatMoney(cart.total_price,$('body').data('money-format')));
            $('.header-i-cart.mini-cart-page').addClass('mini-showed');
            setTimeout(function(){
              $('.header-i-cart.mini-cart-page').removeClass('mini-showed');
            },5000);
          }
        },
        complete: function(){
          $('.add_btn').text("Add to cart");
        }
      });
    }
  });
}
/* end product page */

/* cart page */
var errTimeoutId;
function cart_update(id, qty, err) {
  $.ajax({
    type: 'POST',
    url: '/cart/change.js',
    dataType: 'json',
    data:{
      id:id,
      quantity:qty
    },
    success: function(data){
      $.ajax({
        url: '/cart',
        type: 'get',
        dataType: 'html',
        success: function(cartHTML) {
          var cartpage = $(cartHTML).find('.cart-page').html();
          $('.cart-page').html(cartpage);
          
          var minicart = $(cartHTML).find('.mini-cart-page').html();
          $('.mini-cart-page').html(minicart);
          
          var cartCount =  $(cartHTML).find('.cart-products-count').text();
          $('.cart-products-count').text(cartCount);
          
          $('.img-loader').hide();
          
          if(err != '') {
            $('.cart-error').text(err).show();
            $('html, body').animate({scrollTop: $('.cart-error').offset().top - $('header').innerHeight()},1000)
            clearTimeout(errTimeoutId);

            setTimeout(function(){
              $('.cart-error').text('').hide();
            }, 5000);

          }

        }
      });
    }
  });
}
/* end cart page */
